document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]');
  const menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu){
    toggle.addEventListener('click',()=>{
      const open=menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded',open?'true':'false');
      menu.setAttribute('aria-hidden',open?'false':'true');
    });
  }
  const discount=document.querySelector('[data-discount-form]');
  if(discount) discount.addEventListener('submit',e=>{
    e.preventDefault();
    const code=discount.querySelector('input')?.value.trim();
    if(code) window.location.href='/discount/'+encodeURIComponent(code)+'?redirect=/cart';
  });
});